<div class="modal-header">
  <h5 class="modal-title">Account mit Google erstellen</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <p class="modal-description">
    Um die Registrierung abzuschließen, wähle bitte einen Benutzernamen und
    akzeptiere unsere Nutzungsbedingungen.
  </p>

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>

  <form (submit)="submit()" id="google-registration-form">
    <mdb-form-control class="mb-4">
      <input
        class="form-control"
        type="text"
        autocomplete="username"
        name="username"
        id="google-username"
        [(ngModel)]="username"
        required
        minlength="3"
        maxlength="32"
        mdbInput
      />
      <label class="form-label" for="google-username" mdbLabel
        >Benutzername</label
      >
    </mdb-form-control>

    <div class="form-check mb-4">
      <input
        class="form-check-input"
        type="checkbox"
        name="accept-tos"
        id="accept-tos"
        [(ngModel)]="acceptTOS"
        required
        mdbCheckbox
      />
      <label class="form-check-label" for="accept-tos">
        Ich akzeptiere die <a href="/agb" target="_blank">AGB</a> und die
        <a href="/datenschutz" target="_blank">Datenschutzerklärung</a>
      </label>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    uiButton="neutral"
    (click)="cancel()"
    [disabled]="isSubmitting"
  >
    Abbrechen
  </button>
  <button
    type="submit"
    uiButton
    [disabled]="!isFormValid || isSubmitting"
    (click)="submit()"
  >
    <span *ngIf="!isSubmitting">
      <i class="fas fa-user-plus"></i>
      Account erstellen
    </span>
    <span *ngIf="isSubmitting">
      <i class="fas fa-spinner fa-spin"></i>
      Wird erstellt...
    </span>
  </button>
</div>
